import { urls } from '@/urls';
import { useEffect, useState } from 'react';
import { fetchWrapper } from '@/lib/fetch-wrapper';
import { Box } from '@mui/material';
import { Loader } from '@/components/loader/loader';
import { CHART_COLORS } from '@/components/ui';
import { formatCurrencyNoUnit } from '@/lib/formatters';
import { SvgDonut, ChartLegend } from '@/components/ds/charts';

export default function OptimizationPotential(props: any) {
  const [chartItems, setChartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchWrapper
      .get(urls.DevOps.optimizationPotential)
      .then((data) => {
        setChartItems(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('There was an error!', error);
        setError(error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight={310}>
        Error loading data.
      </Box>
    );
  }

  const chartData = chartItems.map((item: any) => [
    {
      id: 'Efficient Spending',
      value: item.real_cost || 0,
      label: 'Efficient Spending',
      color: CHART_COLORS[0],
    },
    {
      id: 'Active Saving Potential',
      value: item.active_optimization_potential || 0,
      label: 'Active Saving Potential',
      color: CHART_COLORS[1],
    },
    {
      id: 'Rejected Savings',
       value: item.rejected_savings || 0,
      label: 'Rejected Savings',
      color: CHART_COLORS[2],
    }
  ]).flat();

  // Calculate total cost for percentage
  const totalCost = chartData.reduce((sum, item) => sum + item.value, 0);

  const donutData = chartData.map((item) => ({
    v: totalCost > 0 ? (item.value / totalCost) * 100 : 0,
    c: item.color,
    l: item.label,
    tv: formatCurrencyNoUnit(item.value),
  }));

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2.5,
      }}>
      <SvgDonut
        data={donutData}
        centerTop="Total"
        centerBot={formatCurrencyNoUnit(totalCost)}
        size={240}
      />
      <Box sx={{ width: '100%', maxWidth: 340 }}>
        <ChartLegend
          items={chartData.map((item) => ({
            color: item.color,
            name: item.label,
            value: formatCurrencyNoUnit(item.value),
          }))}
        />
      </Box>
    </Box>
  );
}
